import { useContext, useEffect, useMemo } from 'react';

import { useQuery } from '@apollo/client';
import { GET_INSTALLER_SEALS_QUERY } from 'Queries/Queries';
import { ErrorHandlingContext } from 'context/ErrorHandling';

import {
  DEB_CURRENT_TEST_SUITE,
  shouldFillDebTestData,
} from 'components/DEBForm/Utils/DebTestSetup';

export const useCurrentSeals = () => {
  const { setShowError } = useContext(ErrorHandlingContext);
  const { data, loading, error } = useQuery(GET_INSTALLER_SEALS_QUERY);

  const seals = useMemo(
    () =>
      shouldFillDebTestData
        ? DEB_CURRENT_TEST_SUITE.installerData.seals
        : data?.getInstallerSeals ?? null,
    [data]
  );

  useEffect(() => {
    if (error) {
      console.error('useCurrentSeals error:', error);
      setShowError((prev) => !prev && true); // Prevent multiple triggers
    }
  }, [error, setShowError]);

  return { seals, isLoading: loading };
};
